import React, { PropTypes, Component } from 'react';
import { AuthStore } from 'stores';
import shallowEqual from 'shallowequal';
import { mixin, RefluxMixin } from 'Util';
import ProfileLogout from './ProfileLogout';
import AuthActions from 'actions/Auth';

export default class ProfileLogoutContainer extends mixin(
  RefluxMixin,
  Component
) {
  static displayName = 'ProfileFooterContainer';

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  logout() {
    AuthActions.logout();
  }

  render() {
    return <ProfileLogout logout={this.logout.bind(this)} />;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/ProfileLogoutContainer.js